<template>
  <dv-border-box-10 id="scroll-board">
    <!-- <div class="ranking-board-title">报警故障记录</div> -->
    <!-- <dv-scroll-board :config="config" @click="tableClick" /> -->
    <block>
      <div slot="head">
        <tab :tabList="tabList" @onChange="tabChange"></tab>
      </div>
      <div
        slot="content"
        style="height: 46.2vh;overflow: auto"
        @scroll="tableScroll"
        id="scroll-table-id"
        :class="
          currentTab == 'alarm' || isFarRight ? '' : 'xAxis-scroll-hidden'
        "
      >
        <scroll-table
          v-if="currentTab == 'real'"
          :data="stationDataComputed"
          :options="wzRealOption"
          :tableStyle="tableStyle"
          :currentTab="currentTab"
        >
        </scroll-table>

        <scroll-table
          v-if="currentTab == 'alarm'"
          :data="abnormalList"
          :options="alarmRecordOption"
          :tableStyle="tableStyle"
          :currentTab="currentTab"
        >
        </scroll-table>
      </div>
    </block>
    <scrollTable />
  </dv-border-box-10>
</template>

<script>
import { mapState } from "vuex";
import { getWindDirectionDesc } from "@/utils/utils";
import block from "@/components/global/block";
import tab from "@/components/global/tab";
import scrollTable from "@/components/global/scrollTable";

// const tabList = [
//   { name: "微站数据", value: "real" },
//   { name: "报警故障记录", value: "alarm" }
// ];

const alarmRecordOption = [
  { label: "#", value: "index", width: "2.6vw" },
  { label: "时间", value: "update_time", width: "8.85vw", link: true },
  { label: "报警站点", value: "station_name", width: "5.8vw" },
  { label: "报警类型", value: "type_name", width: "8.85vw" },
  {
    label: "报警数值",
    value: "value",
    width: "5.20vw",
    round: true,
    roundKey: "data_type"
  }
];

export default {
  name: "ScrollBoard",
  components: {
    block,
    tab,
    scrollTable
  },
  computed: {
    ...mapState([
      "abnormalList",
      "stationData",
      "sensortypes",
      "page_config",
      "user_power"
    ]),
    wzRealOption() {
      let wzRealOption = [];
      if (this.page_config.showWind) {
        wzRealOption = this.sensortypes.map(item => ({
          ...item,
          width: "4.17vw",
          round: true
        }));
        wzRealOption = [
          { label: "#", value: "index", width: "1.56vw" },
          { label: "微站名称", value: "name", width: "5.21vw", link: true },
          { label: "水质类别", value: "category", width: "3vw" },
          ...wzRealOption,
          {
            label: "风向",
            value: "wind_direction",
            width: "2.08vw"
          }
        ];
      } else {
        wzRealOption = _page_config.sensortypes.map(item => ({
          ...item,
          width: "4.1vw",
          round: true
        }));
        wzRealOption = [
          { label: "#", value: "index", width: "1.56vw" },
          { label: "微站名称", value: "name", width: "8.85vw", link: true },
          { label: "水质类别", value: "category", width: "3vw" },
          ...wzRealOption
        ];
      }
      return wzRealOption;
    },
    stationDataComputed() {
      return (
        this.stationData &&
        this.stationData.map(item => {
          return {
            ...item,
            wind_direction: item.wind_direction
              ? getWindDirectionDesc(item.wind_direction)
              : "--"
          };
        })
      );
    }
  },
  watch: {
    abnormalList() {
      // this.config = {
      //   header: ["时间", "报警站点", "报警类型", "报警数值"],
      //   data: this.abnormalList,
      //   index: true,
      //   columnWidth: [50, 170, 120, 170],
      //   align: ["center"],
      //   rowNum: 7,
      //   headerBGC: "rgb(0, 73, 154)", //"#1981f6",
      //   headerHeight: 45,
      //   oddRowBGC: "rgba(0, 44, 81, 0.8)",
      //   evenRowBGC: "rgba(10, 29, 50, 0.8)"
      // };
      // console.log(this.abnormalList)
    }
  },
  data() {
    return {
      alarmRecordOption,
      tabList: [],
      currentTab: "",
      config: {},
      tableStyle: {
        bodyHeight: "40vh",
        tableHeight: "100%"
      },
      isFarRight: false
    };
  },
  created() {
    let menus = this.user_power.menus;
    for (let item of menus) {
      this.tabList.push({ name: item.description, value: item.name });
    }
  },
  methods: {
    tableScroll() {
      if (this.currentTab == "alarm") {
        return;
      }
      const container = document.getElementById("scroll-table-id");
      // 当 x 轴滚动位置达到右侧时触发事件
      // const scrollX = container.scrollLeft; // 获取当前的 x 轴滚动位置
      if (
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth
      ) {
        this.isFarRight = true;
      } else {
        this.isFarRight = false;
      }
    },
    tableClick(v) {
      console.log(v);
    },
    abnormalListFormat() {
      let data_list = this.abnormalList;
      let new_data = [];
      for (let i of data_list) {
      }
    },
    tabChange(v) {
      this.currentTab = v;
      // this.closeMapWindow()
    }
  }
};
</script>

<style lang="less">
#scroll-board {
  // width: 50%;
  box-sizing: border-box;
  // margin-left: 20px;
  height: 59.5%;
  overflow: hidden;
}

.ranking-board-title {
  font-weight: bold;
  height: 4.63vh;
  display: flex;
  align-items: center;
  font-size: 1.85vh;
  color: white;
  padding-left: 1vw;
}
.xAxis-scroll-hidden::-webkit-scrollbar {
  width: 0;
}
</style>
